import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../../utils/api";
import { title } from "../../text/page-title.text";
import { extraMsg, msg } from "../../text/form-message.text";
import { label } from "../../text/labels.text";
import { button } from "../../text/button.text";
import { href } from "../../utils/ui-urls";
import { linkText } from "../../text/links.text";
import { formTitle } from "../../text/form-title.text";
import Tabs from "../../components/tabs/tabs.component";
import {
  InputSocialSecurity,
  InputOTP,
  Button,
  Title,
  ProgressIndicator,
  Label,
  InputPhone,
} from "@creditonebank/c1b-components";
import { headline } from "../../text/form-headline.text.js";
import { withoutGlobalPinMsg } from "../../text/messages-without-globalpin.text";
import Alert from "../../components/alert/alert.component";
import { LoaderComponent } from "../../components/loader/loader.component";
import { errorMsg } from "../../text/error-message.text";
import { errorResponse } from "../../text/error.responses.text";
import { axiosInstance } from "../../service/https.service";
import { checkServerError } from "../../functions/check-server-error.function";

const ResendActivation = ({
  baseAPI,
  signInUrl,
  globalPinFlag,
  stepNumber,
  stepNames,
  mobileStepNames,
}) => {
  useEffect(() => {
    document.title = title.resendActivationMail;
    document.getElementById("governmentIdentifier__input__adv__helper")?.setAttribute("x-apple-data-detectors", false);
    window.scrollTo(0, 0);
  }, []);

  const [phone, setPhone] = useState("");
  const [phoneError, setPhoneError] = useState(false);
  const [governmentIdentifier, setGovernmentIdentifier] = useState("");
  const [ssnError, setSsnError] = useState("");
  const [globalPin, setGlobalPin] = useState("");
  const [errorTitle, setErrorTitle] = useState("");
  const [errorDescription, setErrorDescription] = useState("");
  const [error, setError] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const navigate = useNavigate();

  function handleSubmit(e) {
    e.preventDefault();
    setErrorTitle("");
    setErrorDescription("");
    setError(false);
    setPhoneError(false);
    setSsnError(false);

    if (
      phone === "" &&
      governmentIdentifier === "" &&
      globalPinFlag === false
    ) {
      setError(true);
      setErrorTitle(errorMsg.missingPhoneAndGovtId.errorTitle);
      setErrorDescription(errorMsg.missingPhoneAndGovtId.errorDesc);
      window.scrollTo(0, 0);
    } else if (phone === "") {
      setErrorTitle(errorMsg.missingPhoneValue.errorTitle);
      setErrorDescription(errorMsg.missingPhoneValue.errorDesc);
      setPhoneError(true);
      window.scrollTo(0, 0);
    } else if (governmentIdentifier === "") {
      setErrorTitle(errorMsg.missingGovtId.errorTitle);
      setErrorDescription(errorMsg.missingGovtId.errorDesc);
      setSsnError(true);
      window.scrollTo(0, 0);
    } else {
      setShowLoader(true);
      axiosInstance
        .post(
          baseAPI + api.resendActivationMail,
          {
            phone: phone,
            governmentIdentifier: governmentIdentifier,
            globalPin: globalPin,
          },
          {
            headers: {
              accessEmail: false,
            },
          }
        )
        .then((response) => {
          setShowLoader(false);
          if (response.data.factors.length === 0) {
            navigate(href.requestError);
          } else {
            let phone = response.data.phone;
            let email = response.data.email;
            let primaryPhone = response.data.primaryPhone;

            let formatPrimaryPhone;
            let formatMobile;
            let formatEmail;

            //redirect if email is valid
            if (email !== undefined) {
              navigate(href.resendActivationSuccess, {
                state: {
                  email: email
                }
              });
            }
            else {
              //formatting and masking phone number
              if (phone !== null && phone !== "" && phone !== undefined) {
                formatMobile = `${phone.slice(0, 3)} ${"*".repeat(5)} ${"*".repeat(1) + phone.slice(-4)
                  } `;
              }
              //formatting and masking primary phone number
              if (
                primaryPhone !== null &&
                primaryPhone !== "" &&
                primaryPhone !== undefined
              ) {
                formatPrimaryPhone = `${primaryPhone.slice(0, 3)} ${"*".repeat(
                  5
                )} ${"*".repeat(1) + primaryPhone.slice(-4)} `;
              }

              //masking email
              if (email !== null && email !== "" && email !== undefined) {
                let sliceEmail = email.indexOf("@");
                let username = email.slice(0, sliceEmail);
                let domain = email.slice(sliceEmail);
                formatEmail = `${username.charAt(0)}${"*".repeat(
                  3
                )}${username.charAt(username.length - 1)}${domain}`;
                formatEmail = formatEmail.toLowerCase();
              }

              navigate(href.mfaChallenge, {
                state: {
                  id: response.data.id,
                  factors: response.data.factors,
                  email: formatEmail,
                  phone: formatMobile,
                  primaryPhone: formatPrimaryPhone,
                  navigateHref: href.updateEmail,
                },
              });
            }
          }
        })
        .catch((error) => {
          if (checkServerError(error.response.status)) {
            setShowLoader(false);
            setErrorTitle(errorMsg.internalServer.errorTitle);
            setErrorDescription(errorMsg.internalServer.errorDesc);
            setError(true);
            window.scrollTo(0, 0);
          } else {
            setShowLoader(false);
            if (
              error.response.data.error.title ===
              errorResponse.accountAlreadyActiveError
            ) {
              navigate(href.accountActive);
            } else if (
              error.response.data.error.title ===
              errorResponse.problemProcessingRequest
            ) {
              navigate(href.requestError);
            } else if (
              error.response.data.error.title ===
              errorMsg.errorResendActivation.errorTitle
            ) {
              setErrorTitle(error.response.data.error.title);
              setErrorDescription(errorMsg.errorResendActivation.errorDesc);
              setError(true);
              window.scrollTo(0, 0);
            } else {
              setErrorTitle(error.response.data.error.title);
              setErrorDescription(error.response.data.error.message);
              setError(true);
              window.scrollTo(0, 0);
            }
          }
        });
    }
  }

  const handleChange = () => {
    setError(false);
    setPhoneError(false);
    setSsnError(false);
  };

  const handleSignIn = () => {
    window.location.href = signInUrl;
  };

  const handleResendActivationMail = () => {
    navigate(href.resendActivationMail);
  };

  return (
    <div className="bg">
      <div className="progress-stepper-style validate-progress">
        <ProgressIndicator
          className="web-progress-stepper"
          currentIndex={stepNumber}
          stepNames={stepNames}
        />
        <ProgressIndicator
          className="mobile-progress-stepper"
          currentIndex={stepNumber}
          stepNames={mobileStepNames}
        />
      </div>
      {showLoader ? (
        <LoaderComponent />
      ) : (
        <div className="div-container">
          <div className="form-element-resend-activation">
            <form onSubmit={(e) => handleSubmit(e)} className="fp-form">
              <div className="title title-mobile">
                <Title tag="h2" className="web-title">
                  {formTitle.resendActivationMail}
                </Title>
                <Title tag="h2" className="web-title">
                  {" "}
                  {formTitle.resendActivationMail2}
                </Title>

                <Title tag="h2" className="mobile-title" align="center">
                  {formTitle.resendActivationMail}
                </Title>
                <Title tag="h2" className="mobile-title" align="center">
                  {" "}
                  {formTitle.resendActivationMail2}
                </Title>
              </div>

              <div className="feedback-alert">
                <Alert
                  alertType="error"
                  title={errorTitle}
                  description={errorDescription}
                  showAlert={error || phoneError || ssnError}
                />
              </div>

              <div className="description">
                <p className="headline-style">
                  {headline.resendActivationMail}
                </p>
                <p className="desc2">
                  {globalPinFlag
                    ? msg.resendActivation
                    : withoutGlobalPinMsg.resendActivation}
                </p>
              </div>

              <div className="box-with-link">
                <Label error={error || phoneError}>{label.phone}</Label>
                <InputPhone
                  id="phone"
                  value={phone}
                  name="phone-input"
                  setValue={setPhone}
                  error={error || phoneError}
                  noErrorsOrHelper
                  hideAlertIcon
                  autoFocus
                  onChange={handleChange}
                  data-testid="test-phone"
                />
                <Button
                  variant="link"
                  size="small"
                  style={{ padding: "0", margin: "0" }}
                  onClick={handleResendActivationMail}
                >
                  {linkText.accessEmail}
                </Button>
              </div>

              {globalPinFlag ? (
                <div className="tab-gap-resend">
                  <Tabs>
                    <div label={label.governmentIdentifier}>
                      <InputSocialSecurity
                        id="governmentIdentifier"
                        value={governmentIdentifier}
                        name="governmentIdentifier-input"
                        setValue={setGovernmentIdentifier}
                        error={error || ssnError}
                        noErrorsOrHelper
                        hideAlertIcon
                        description={extraMsg.exampleSSN}
                        onChange={handleChange}
                        data-testid="test-governmentIdentifier"
                      />
                    </div>

                    <div label={label.globalPin}>
                      <InputOTP
                        id="globalPin"
                        value={globalPin}
                        name="globalPin-input"
                        setValue={setGlobalPin}
                        error={error}
                        description={extraMsg.exampleGlobalPin}
                        noErrorsOrHelper
                        hideAlertIcon
                        onChange={handleChange}
                      />
                    </div>
                  </Tabs>
                </div>
              ) : (
                <>
                  <div className="governmentIdentifier-input">
                    <Label error={error || ssnError}>
                      {label.governmentIdentifier}
                    </Label>
                    <InputSocialSecurity
                      id="governmentIdentifier"
                      value={governmentIdentifier}
                      name="governmentIdentifier-input"
                      setValue={setGovernmentIdentifier}
                      error={error || ssnError}
                      noErrorsOrHelper
                      hideAlertIcon
                      description={extraMsg.exampleSSN}
                      onChange={handleChange}
                      data-testid="test-governmentIdentifier"
                    />
                  </div>
                </>
              )}

              <Button
                type="submit"
                onClick={handleSubmit}
                size="medium"
                className="button-style"
                style={{
                  width: "100%",
                  marginTop: "32px",
                  marginBottom: "0px",
                  padding: "12px 32px",
                }}
              >
                {button.resendActivationMail}
              </Button>
            </form>
          </div>
          <div className="resend-activation-image"></div>
        </div>
      )}
      <div className="centre-align out-of-box">
        <p>
          {extraMsg.existingCustomer}
          <Button
            variant="link"
            size="small"
            onClick={handleSignIn}
            style={{ padding: "0" }}
          >
            {linkText.signIn}
          </Button>
        </p>
      </div>
    </div>
  );
};

export default ResendActivation;
